import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { MarcaProductoFindOneInterface } from "../../interfaces/marcaProductosInterfaces/MarcaProductoFindOne.interface";

export async function FinOneMarcaProductoAction (
    MarcaId: string
): Promise<ApiResponse<MarcaProductoFindOneInterface>> {
   const {data} = await apiClient.get(`gpMarcaProductos/${MarcaId}`);
    return {
        status: 200,
        data,
        message: "Marcas de productos obtenida correctamente",
    };
}